import { render, staticRenderFns } from "./ActiveBrandFilterItem.vue?vue&type=template&id=e5c2af2c&scoped=true&"
import script from "./ActiveBrandFilterItem.vue?vue&type=script&lang=js&"
export * from "./ActiveBrandFilterItem.vue?vue&type=script&lang=js&"
import style0 from "./ActiveBrandFilterItem.vue?vue&type=style&index=0&id=e5c2af2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c2af2c",
  null
  
)

export default component.exports